"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_ASSETS_SENTINEL_OWNER_ID = void 0;
exports.GLOBAL_ASSETS_SENTINEL_OWNER_ID = 'org_globalassets00000000000000000000';
//# sourceMappingURL=global-assets-sentinel-owner-id.js.map